import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import * as serviceWorker from "./serviceWorkerRegistration";
import ErrorBoundary from "./components/error-boundary/ErrorBoundary";
import Fallback from "./components/error-boundary/Fallback";

/* ReactDOM.render(
  <React.StrictMode>
    <HandleCache>
      {({ isLoading, isLatestVersionAvailable, clearCacheAndReload }) => {
        if (isLoading) return null;
        if (!isLoading && !isLatestVersionAvailable) {
          clearCacheAndReload();
        }

        return (
          <ErrorBoundary fallback={<Fallback />}>
            <App />
          </ErrorBoundary>
        );
      }}
    </HandleCache>
  </React.StrictMode>,
  document.getElementById("root")
); */

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<Fallback />}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// Vikaaria has moved and this deployment is retired: tear the service worker
// down instead of registering one. The self destructing worker in
// service-worker.js covers the users who are still controlled by an old
// registration and never get this far.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
